export default __webpack_public_path__ + "static/media/25081102.b8b16f48.jpg";